export class StaticTextWidgetPollingRate {
  pollingRate: string = '';
  pollingRateInS: number = -1;
  pollingRateKey: PollingRateKey = PollingRateKey.NO_POLLING;

  constructor(pollingRate: string, pollingRateInS: number, pollingRateKey: PollingRateKey) {
    this.pollingRate = pollingRate;
    this.pollingRateInS = pollingRateInS;
    this.pollingRateKey = pollingRateKey;
  }
}

export enum PollingRateKey  {
  FOUR_HOURS, EIGHT_HOURS, TWENTY_FOUR_HOURS, NO_POLLING
}
